import React from 'react';
import { Typography } from '@mui/material';
import { SurveyComponent } from '../../../../models/SurveyTemplates';

interface TextBlockFieldProps {
    field: SurveyComponent;
    value?: string;
    onChange?: (value: string) => void;
    disabled?: boolean;
}

const TextBlockField: React.FC<TextBlockFieldProps> = ({
    field,
    value,
    onChange,
    disabled = false
}) => {
    const variant = (field.properties?.variant) || 'body1';
    const align = (field.properties?.align) || 'left';
    const text = field.properties?.text || field.description || field.label;

    return (
        <Typography
            variant={variant}
            align={align}
            color="text.secondary"
            sx={{
                mb: 1,
                lineHeight: 1.6,
            }}
        >
            {text}
        </Typography>
    );
};

export default TextBlockField;
